import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonModule } from '@fino-ui/button';
import {
  SubmittableForm,
  validateMaxLength,
  validateMinLength,
} from '@fino-ui/forms';
import { FinoInputModule } from '@fino-ui/input';
import { BaseModalComponent } from '@fino-ui/modal';
import { TranslationModule } from '@fino-ui/translation';
import { PleaseBePatientComponent } from '../../../../components/please-be-patient/please-be-patient.component';
import { BLZPipe } from '../../../../core/pipes/blz.pipe';

@Component({
  selector: 'app-blz-fusion',
  templateUrl: './blz-fusion.component.html',
  styleUrl: './blz-fusion.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslationModule,
    PleaseBePatientComponent,
    FormsModule,
    ReactiveFormsModule,
    FinoInputModule,
    ButtonModule,
    BLZPipe,
  ],
})
export class BlzFusionComponent extends BaseModalComponent<
  {
    deprecatedBankCodes?: string[];
  },
  string[]
> {
  constructor() {
    super();
    Object.assign(this, this.data ?? {});
  }

  form = new SubmittableForm({
    blz: new FormControl('', [
      Validators.required,
      validateMinLength(8),
      validateMaxLength(8),
    ]),
  });

  deprecatedBankCodes: string[];

  addBlz($event) {
    $event.stopPropagation();
    const { blz } = this.form.value;
    if (this.form.valid && !this.deprecatedBankCodes.includes(blz)) {
      this.deprecatedBankCodes.push(this.form.value.blz);
      this.form.reset();
    }
  }

  get noBlzToBeFusioned() {
    return this.deprecatedBankCodes.length === 0;
  }

  removeBlz(blz) {
    this.deprecatedBankCodes.splice(this.deprecatedBankCodes.indexOf(blz), 1);
  }

  get formNotTouched() {
    return this.form.pristine;
  }

  abort() {
    this.close();
  }

  submit() {
    this.result = this.deprecatedBankCodes;
    this.close();
  }
}
